import { render, staticRenderFns } from "./CMAssignCourseConfigurationBody.vue?vue&type=template&id=f7568e90&lang=pug"
import script from "./CMAssignCourseConfigurationBody.vue?vue&type=script&lang=js"
export * from "./CMAssignCourseConfigurationBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports